// Mock data for The Supreme Courts — replace with backend later.

export const CONTACT = {
  phone: "+63 920 961 5610",
  phoneRaw: "+639209615610",
  email: "rtsports317@gmail.com",
  addressLine1: "200 Leonardo St, Vitalez Compound",
  addressLine2: "Sucat, Parañaque City",
  mapQuery: "The Supreme Courts, 200 Leonardo St, Vitalez Compound, Sucat, Paranaque City",
};

export const SOCIALS = [
  { name: "Facebook", href: "#", icon: "facebook" },
  { name: "Twitter", href: "#", icon: "twitter" },
  { name: "Instagram", href: "#", icon: "instagram" },
  { name: "Youtube", href: "#", icon: "youtube" },
];

export const NAV = {
  left: [
    {
      label: "Virtual Tour",
      to: "/virtual-tour",
      children: [
        { label: "The Facility", to: "/virtual-tour#facility" },
        { label: "Pickleball Courts", to: "/virtual-tour#pickleball" },
        { label: "Padel Courts", to: "/virtual-tour#padel" },
        { label: "Pro Shop & Lounge", to: "/virtual-tour#lounge" },
      ],
    },
    { label: "DUPR", to: "/dupr" },
    { label: "Partners and Sponsors", to: "/partners" },
  ],
  right: [
    {
      label: "Events and Tournaments",
      to: "/events",
      children: [
        { label: "Upcoming Events", to: "/events#upcoming" },
        { label: "Open Play", to: "/events#open-play" },
        { label: "Leagues", to: "/events#leagues" },
        { label: "Clinics & Coaching", to: "/events#clinics" },
      ],
    },
    { label: "Rates and Fees", to: "/rates" },
    { label: "Book Now!", to: "/book" },
  ],
};

export const HERO = {
  eyebrow: "NOW SERVING!",
  headline: "NOW SERVING!",
  subtext:
    "Now open in the heart of Sucat, Parañaque — the first purpose-built, multi-court Pickleball and Padel facility in the city. Come rally with us.",
  cta: { label: "Secure Your Spot", to: "/book" },
  image:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_courts-design-draft/artifacts/ee6sgu5e_hero%20front%20image%20sc1.png",
};

export const DUPR = {
  eyebrow: "Get Rated",
  title: "DUPR — THE FUTURE OF PICKLEBALL RATING",
  body:
    "Join over 1 million DUPR-rated pickleball players in playing matches, building community, and improving as a player. Claim your profile today to log your scores, discover local clubs, and unlock your true potential on the court.",
  videoId: "JVT4LSWwGXE",
  poster:
    "https://images.unsplash.com/photo-1737476997205-b3336182f215?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxwaWNrbGViYWxsJTIwcGxheWVyfGVufDB8fHx8MTc5MDE0MzcyMnww&ixlib=rb-4.1.0&q=85",
};

export const OPEN_PLAY = {
  title: "Open Play Schedules",
  slots: [
    { day: "Monday", time: "5am – 9pm" },
    { day: "Tuesday", time: "5am – 9pm" },
    { day: "Wednesday", time: "5am – 9pm" },
    { day: "Thursday", time: "5am – 9pm" },
    { day: "Friday", time: "5am – 9pm" },
    { day: "Saturday", time: "6am – 9pm" },
    { day: "Sunday", time: "7am – 8pm" },
  ],
};

export const PLAY_SECTION = {
  overline: "PLAY",
  body:
    "Freshly surfaced, cushioned indoor courts with tournament-grade lighting and net systems. Whether you are drilling, playing open rec, or battling it out in a league night — every rally feels supreme.",
  price: "₱700/hr",
  priceNote: "weekday off-peak per court",
  cta: { label: "Reserve a Court", to: "/book" },
  image:
    "https://images.unsplash.com/photo-1689942963385-f5bd03f3b270?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxwYWRlbCUyMGNvdXJ0fGVufDB8fHx8MTc5MDE0MzcxNHww&ixlib=rb-4.1.0&q=85",
};

export const FEATURES = [
  {
    title: "4 Pickleball Courts",
    desc: "Dedicated, purpose-built indoor courts with premium cushioned surfacing.",
    icon: "layout-grid",
  },
  {
    title: "1 Padel Court",
    desc: "Glass-walled panoramic padel court — the fastest-growing racquet sport.",
    icon: "square",
  },
  {
    title: "Pro Shop & Lounge",
    desc: "Gear, demos, cold drinks and a place to hang between games.",
    icon: "shopping-bag",
  },
  {
    title: "Coaching & Clinics",
    desc: "Certified coaches, beginner clinics and junior development programs.",
    icon: "graduation-cap",
  },
];

export const RATES = [
  {
    name: "Entrance Fee",
    price: "₱100",
    unit: "/ non-member",
    highlight: false,
    features: [
      "Members — entry waived",
      "Non-members — ₱100 per visit",
      "Access to all facilities",
    ],
    cta: "Become a Member",
  },
  {
    name: "Pickleball Court",
    price: "₱700",
    unit: "/ hour",
    highlight: true,
    features: [
      "Weekday Off-Peak — ₱700/hr",
      "Weekday Peak — ₱750/hr",
      "Weekend/Holiday Off-Peak — ₱800/hr",
      "Weekend/Holiday Peak — ₱850/hr",
    ],
    cta: "Book a Court",
  },
  {
    name: "Padel Court",
    price: "₱1,400",
    unit: "/ hour",
    highlight: false,
    features: [
      "Weekday Off-Peak — ₱1,400/hr",
      "Weekday Peak — ₱1,500/hr",
      "Weekend/Holiday Off-Peak — ₱1,500/hr",
      "Weekend/Holiday Peak — ₱1,600/hr",
    ],
    cta: "Book a Court",
  },
];

export const PEAK_HOURS = [
  { day: "Weekday", pickleball: "5 PM – 11 PM", padel: "5 PM – 11 PM" },
  { day: "Weekend / Holiday", pickleball: "9 AM – 11 AM · 4 PM – 11 PM", padel: "9 AM – 11 AM · 4 PM – 11 PM" },
];

export const EVENTS = [
  {
    title: "Grand Opening Doubles Shootout",
    date: "Aug 30, 2025",
    tag: "Tournament",
    level: "All Levels",
    image:
      "https://images.unsplash.com/photo-1659318006095-4d44845f3a1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxwaWNrbGViYWxsJTIwdG91cm5hbWVudHxlbnwwfHx8fDE3OTAxNDM3MTV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Sunset Open Play Sessions",
    date: "Every Fri, 6–9pm",
    tag: "Open Play",
    level: "2.5 – 4.0",
    image:
      "https://images.pexels.com/photos/32975182/pexels-photo-32975182.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Supreme League Season 1",
    date: "Sep – Nov 2025",
    tag: "League",
    level: "3.0 – 4.5",
    image:
      "https://images.pexels.com/photos/32975185/pexels-photo-32975185.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Beginner Clinic: Learn in a Day",
    date: "Every Sat, 9am",
    tag: "Clinic",
    level: "Beginner",
    image:
      "https://images.pexels.com/photos/29439346/pexels-photo-29439346.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const PARTNERS = [
  { name: "DUPR", type: "Rating Partner" },
  { name: "RT Sports, Inc.", type: "Sports Consulting" },
  { name: "Selkirk", type: "Equipment" },
  { name: "JOOLA", type: "Equipment" },
  { name: "Franklin", type: "Official Ball" },
  { name: "Gatorade", type: "Hydration" },
  { name: "Yonex", type: "Padel" },
  { name: "Head", type: "Padel" },
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1618551763300-dc7eb8ce3560?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxwaWNrbGViYWxsJTIwYWN0aW9ufGVufDB8fHx8MTc5MDE0MzcxNXww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/38155778/pexels-photo-38155778.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1658491830143-72808ca237e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxwYWRlbCUyMGNvdXJ0fGVufDB8fHx8MTc5MDE0MzcxNHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1775993167393-f2add1f8eec2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxpbmRvb3IlMjBjb3VydHxlbnwwfHx8fDE3OTAxNDM3MjJ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/17299533/pexels-photo-17299533.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/38208389/pexels-photo-38208389.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const TOUR = {
  headline: "STEP INSIDE THE SUPREME COURTS",
  body:
    "Take a virtual walk through our purpose-built facility — from the pickleball battle courts to the panoramic glass padel arena and the players' lounge.",
  videoId: "H98xmwr6AcU",
  poster:
    "https://images.unsplash.com/photo-1775993167393-f2add1f8eec2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxpbmRvb3IlMjBjb3VydHxlbnwwfHx8fDE3OTAxNDM3MjJ8MA&ixlib=rb-4.1.0&q=85",
  spots: [
    { id: "facility", title: "The Facility", desc: "10,000 sq ft of climate-controlled, tournament-grade playing space." },
    { id: "pickleball", title: "Pickleball Courts", desc: "4 dedicated courts with premium cushioned surfacing and pro lighting." },
    { id: "padel", title: "Padel Courts", desc: "1 panoramic glass-walled padel court — a first for the city." },
    { id: "lounge", title: "Pro Shop & Lounge", desc: "Gear up, hydrate, and hang out between games." },
  ],
};

export const RESERVATION_OPTIONS = {
  sports: ["Pickleball", "Padel"],
  durations: ["1 hour", "1.5 hours", "2 hours"],
  times: [
    "6:00 AM", "7:00 AM", "8:00 AM", "9:00 AM", "10:00 AM", "11:00 AM",
    "12:00 PM", "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM", "5:00 PM",
    "6:00 PM", "7:00 PM", "8:00 PM",
  ],
};

export const RT_SPORTS = {
  name: "RT Sports, Inc.",
  tagline: "Sports facility management company",
};

// External booking system
export const BOOKING_URL = "https://thesupremecourts.bookacourtph.com";

export const NAV2 = [
  {
    label: "About Us",
    to: "/about",
    children: [{ label: "RT Sports, Inc.", to: "/about#rt-sports" }],
  },
  {
    label: "The Courts",
    to: "/courts/pickleball",
    children: [
      { label: "Pickleball Courts", to: "/courts/pickleball" },
      { label: "Padel Courts", to: "/courts/padel" },
      { label: "Pro Shop", to: "/courts/proshop" },
      { label: "Sports Bar & Restaurant", to: "/courts/sports-bar" },
    ],
  },
  { label: "Partners and Sponsors", to: "/partners" },
  { label: "Events and Tournaments", to: "/events" },
  { label: "Rates and Fees", to: "/rates" },
];

export const ABOUT = {
  eyebrow: "About Us",
  title: "Owned & operated by RT Sports",
  hero:
    "https://images.unsplash.com/photo-1779862761891-1fff60bda7cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxpbmRvb3IlMjBwaWNrbGViYWxsJTIwY291cnR8ZW58MHx8fHwxNzkwMTUxNzUzfDA&ixlib=rb-4.1.0&q=85",
  intro:
    "The Supreme Courts is owned and operated by RT Sports, Inc. — the first purpose-built, multi-court pickleball and padel destination in the heart of Sucat, Parañaque.",
  body:
    "From tournament-grade indoor courts to a full pro shop and a sports bar & restaurant, every corner is designed to keep you moving, connected, and coming back. Whether you're picking up a paddle for the first time or chasing a higher DUPR, there's a court here for you.",
  values: [
    { title: "Community First", desc: "A welcoming home for players of every age and skill level." },
    { title: "World-Class Courts", desc: "Cushioned, tournament-grade surfaces built to play right." },
    { title: "Play & Stay", desc: "Eat, drink, shop and hang out long after the final point." },
  ],
  rt: {
    title: "RT Sports, Inc.",
    tagline: "Sports facility management company",
    body:
      "RT Sports, Inc. is a sports facility management company. It currently owns and operates The Supreme Courts — a premium Pickleball and Padel facility located at the heart of Sucat, Parañaque.",
    body2:
      "Planning to build your own Pickleball or Padel facility? RT Sports, Inc. can help you at every stage — from first idea to opening day and beyond.",
    services: [
      "Market research",
      "Planning",
      "Supplier selection",
      "Construction management",
      "Marketing & promotion",
      "Price structuring",
      "Operations management",
    ],
    image: "/courts/rt-sports.jpg",
  },
};

export const COURTS = {
  pickleball: {
    slug: "pickleball",
    eyebrow: "The Courts",
    title: "Pickleball Courts",
    tagline: "4 dedicated, tournament-grade indoor courts.",
    hero: "/courts/pickleball-hero.jpg",
    body:
      "Four purpose-built indoor pickleball courts with premium cushioned surfacing, pro-grade lighting and tournament net systems. Book by the hour, drop in for rated open play, or battle it out on league nights.",
    features: [
      "4 cushioned indoor courts",
      "Tournament-grade lighting",
      "DUPR-rated open play daily",
      "Balls & nets provided",
    ],
    stats: [
      { value: "4", label: "Courts" },
      { value: "16h", label: "Open Daily" },
      { value: "₱700", label: "Per Hour" },
    ],
    gallery: [
      "/courts/pickleball-1.jpg",
      "/courts/pickleball-2.jpg",
      "/courts/pickleball-3.jpg",
      "/courts/pickleball-4.jpg",
    ],
  },
  padel: {
    slug: "padel",
    eyebrow: "The Courts",
    title: "Padel Courts",
    tagline: "A panoramic glass-walled padel court — a first for the city.",
    hero: "/courts/padel-hero.jpg",
    body:
      "One stunning panoramic padel court with full glass walls and pro turf. Padel is the world's fastest-growing racquet sport — easy to learn, endlessly addictive, and always played as doubles.",
    features: [
      "1 panoramic glass court",
      "Pro turf surfacing",
      "Racquets available to rent",
      "Coaching & clinics available",
    ],
    stats: [
      { value: "1", label: "Court" },
      { value: "4", label: "Players / Game" },
      { value: "₱1,400", label: "Per Hour" },
    ],
    gallery: [
      "/courts/padel-1.jpg",
      "/courts/padel-2.jpg",
      "/courts/padel-3.jpg",
      "/courts/padel-4.jpg",
    ],
  },
  proshop: {
    slug: "proshop",
    eyebrow: "The Courts",
    title: "Pro Shop",
    tagline: "Gear up with the latest paddles & apparel.",
    hero: "/courts/proshop-hero.jpg",
    body:
      "Everything you need for game day, all under one roof. Demo the latest pickleball paddles, grab fresh perforated balls and grips, or kit out in Supreme Courts apparel. Our staff will help you find the perfect setup.",
    features: [
      "Latest pickleball paddles",
      "Demo before you buy",
      "Balls, grips & accessories",
      "Supreme Courts apparel",
    ],
    stats: [
      { value: "20+", label: "Brands" },
      { value: "Demo", label: "Try First" },
      { value: "10%", label: "Member Discount" },
    ],
    gallery: [
      "/courts/proshop-1.jpg",
      "/courts/proshop-2.jpg",
      "/courts/proshop-3.jpg",
      "/courts/proshop-4.jpg",
    ],
  },
  "sports-bar": {
    slug: "sports-bar",
    eyebrow: "The Courts",
    title: "Sports Bar & Restaurant",
    tagline: "Refuel, recharge and hang out courtside.",
    hero:
      "https://images.pexels.com/photos/6241298/pexels-photo-6241298.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    body:
      "The bright, family-friendly heart of the clubhouse. Grab a healthy post-match bowl, a fresh smoothie or a barista coffee between games, and catch live pickleball tournaments on the big screens. Great food, great company, great rallies.",
    features: [
      "Big screens with live pickleball",
      "Healthy bowls & fresh food",
      "Smoothies, juices & coffee",
      "Bright, family-friendly space",
    ],
    stats: [
      { value: "7", label: "Days a Week" },
      { value: "12", label: "Screens" },
      { value: "100", label: "Seats" },
    ],
    gallery: [
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxicmlnaHQlMjByZXN0YXVyYW50fGVufDB8fHx8MTc5MDE1ODE5MHww&ixlib=rb-4.1.0&q=85",
      "https://images.pexels.com/photos/34975554/pexels-photo-34975554.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.pexels.com/photos/6241298/pexels-photo-6241298.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
  },
};

export const COURT_LINKS = [
  { slug: "pickleball", title: "Pickleball Courts", tag: "01" },
  { slug: "padel", title: "Padel Courts", tag: "02" },
  { slug: "proshop", title: "Pro Shop", tag: "03" },
  { slug: "sports-bar", title: "Sports Bar & Restaurant", tag: "04" },
];
